var React = require('react');

function Envelope (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.3125 2.25C17.2441 2.25 18 3.00551 18 3.9375C18 4.46836 17.7504 4.96758 17.325 5.2875L9.675 11.025C9.27422 11.3238 8.72578 11.3238 8.325 11.025L0.675 5.2875C0.250066 4.96758 0 4.46836 0 3.9375C0 3.00551 0.755508 2.25 1.6875 2.25H16.3125ZM7.65 11.925C8.45156 12.5262 9.54844 12.5262 10.35 11.925L18 6.1875V13.5C18 14.741 16.991 15.75 15.75 15.75H2.25C1.00723 15.75 0 14.741 0 13.5V6.1875L7.65 11.925Z","fill":"white"}));
}

Envelope.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Envelope;

Envelope.default = Envelope;
